import { IAnyModelType, Instance, types as t } from '@invisr/mobx-state-tree'
import crudActions from './crud-actions'
import Component from './component'
import ref from './reference'
const RESERVED_KEYWORDS = [ "EOF", "SELECT", "FROM", "DISTINCT", "LEFT_PAREN", "RIGHT_PAREN", "WINDOW", "WINDOW_FUNCTION", "UNION", "ALL", "JOIN", "ON", "LEFT", "RIGHT", "INNER", "OUTER", "WHERE", "LIMIT", "ORDER", "BY", "SEPARATOR", "DIRECTION", "GROUP", "HAVING", "MATH", "MATH_MULTI", "OPERATOR", "CONDITIONAL", "NUMBER", "BOOLEAN", "STRING", "DBLSTRING", "LITERAL", "DOT", "FUNCTION", "STAR", "AS" ]

// const PicklistItem = t
//   .model('PicklistItem', {
//     value: t.maybeNull(t.string),
//     label: t.maybeNull(t.string)
//   })

export const FieldBase = t.model('FieldBase', {
  label: t.maybeNull(t.string),
  placeholder: t.maybeNull(t.string),
  fieldPath: t.maybeNull(t.string),
  dataSourceId: t.maybeNull(t.string),
  mappingPath: t.maybeNull(t.string),
  type: t.maybeNull(t.string),
  referenceData: t.frozen(),
  picklist: t.frozen([]),
  computed: t.maybeNull(t.boolean),
  indexed: t.maybeNull(t.boolean),
  code: t.maybeNull(t.string)
}).actions(crudActions)

const optional = (val, def) => t.optional(val, def, [null, undefined])
const isoDate = t.custom({
  name: 'Date',
  fromSnapshot(v: string) {
    return v ? new Date(v) : null
  },
  toSnapshot(v: Date) {
    return v ? v.toISOString() : ''
  },
  isTargetType(v) {
    return v instanceof Date
  },
  getValidationMessage(v) {
    return ''
  }
})

const Field = t.compose('Field', FieldBase, t.model('Field', {
  displayAs: t.frozen(),
  createable: optional(t.boolean, false),
  editable: optional(t.boolean, false),
  required: optional(t.boolean, false),
  isNameField: optional(t.boolean, false),
  isHtmlFormatted: optional(t.boolean, false),
  pivot: optional(t.boolean, false),
  aggregation: optional(t.boolean, false),
  queryable: optional(t.boolean, true),
  searchable: optional(t.boolean, true),
  filterable: optional(t.boolean, true),
  sortable: optional(t.boolean, true),
  revealValue: optional(t.boolean, false),
  referenceTo: t.maybeNull(t.string),
  sobjectAPIName: t.maybeNull(t.string),
  aggregateFunctionName: t.maybeNull(t.string),
  aggregateAlias: t.maybeNull(t.string),
  helpText: t.maybeNull(t.string),
  icon: t.maybeNull(t.union(t.string, t.boolean)),
  numberFormat: t.maybeNull(t.string),
  dateFormat: t.maybeNull(t.string),
  radioAlignment: t.maybeNull(t.string),
  textAreaRows: t.maybeNull(t.number),
  stepSize: t.maybeNull(t.number),
  percentDecimalNumber: t.maybeNull(t.number),
  config: t.frozen(),
  customComponent: ref(t.late((): IAnyModelType => Component), 'components'),
  validRegExp: t.maybeNull(t.string),
  maskRegExp: t.maybeNull(t.string),
  maskReplacement: t.maybeNull(t.string),
  minDate: isoDate,
  maxDate: isoDate,
  maxToday: t.maybeNull(t.boolean),
  minToday: t.maybeNull(t.boolean),
  minNum: t.maybeNull(t.number),
  maxNum: t.maybeNull(t.number),
  maxSelected: t.maybeNull(t.number),
  maxSelectedText: t.maybeNull(t.string),
  textTransform: t.maybeNull(t.string),
  textWrap: t.optional(t.boolean, false),
  innerLabel: t.maybeNull(t.string),
  innerLabelChecked: t.maybeNull(t.string),
  switchLarge: t.maybeNull(t.boolean)
}))
.volatile(self => ({
  error: null
})).views(self => ({
    get aliasedFieldPath () {
      if (self.aggregateAlias && self.aggregateAlias.length) {
        return self.aggregateAlias
      } else if (self.aggregateFunctionName) {
        return self.aggregateFunctionName + '(' + self.fieldPath + ')'
      } else return self.fieldPath
    }
  })).actions(crudActions)
  .actions(self => {
    const superUpdate = self.update
    return {
      update (key: string|object, val?: any) {
        if (key === 'fieldPath') {
          self.error = RESERVED_KEYWORDS.includes(val.toUpperCase()) ? { field: 'fieldPath', message: 'Reserved keyword' } : null
        }
        superUpdate(key, val)
      }
    }
  })

export interface IField extends Instance<typeof Field> {}

export default Field
